const WEEKDAY_LABELS = ['日', '一', '二', '三', '四', '五', '六'];

export const DEFAULT_SLOT_OPTIONS = ['09:00', '11:00', '14:00', '16:00', '19:00', '20:00'];

const formatDateKey = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const buildScheduleDateOptions = (days = 21) => {
  const today = new Date();
  return Array.from({ length: days }, (_, index) => {
    const date = new Date(today);
    date.setDate(today.getDate() + index);
    return {
      key: formatDateKey(date),
      monthDay: `${date.getMonth() + 1}/${date.getDate()}`,
      weekday: WEEKDAY_LABELS[date.getDay()],
      isToday: index === 0
    };
  });
};

interface ScheduleDateOption {
  key: string;
  monthDay: string;
  weekday: string;
  isToday: boolean;
}

interface Props {
  selectedDate: string;
  selectedTime: string;
  onDateChange: (value: string) => void;
  onTimeChange: (value: string) => void;
  dateOptions?: ScheduleDateOption[];
  slotOptions?: string[];
}

const SchedulePicker = ({
  selectedDate,
  selectedTime,
  onDateChange,
  onTimeChange,
  dateOptions = buildScheduleDateOptions(21),
  slotOptions = DEFAULT_SLOT_OPTIONS
}: Props) => {
  return (
    <div>
      <p className="text-xs font-semibold text-slate-500">选择日期</p>
      <div className="mt-2 grid grid-cols-3 gap-2 sm:grid-cols-6 lg:grid-cols-7">
        {dateOptions.map((option) => (
          <button
            key={option.key}
            onClick={() => onDateChange(option.key)}
            className={`rounded-xl border px-2 py-2 text-center transition-colors ${
              selectedDate === option.key
                ? 'border-violet-500 bg-violet-600 text-white'
                : 'border-violet-200 bg-white text-slate-700 hover:border-violet-300'
            }`}
          >
            <p className="text-[11px]">{option.weekday}</p>
            <p className="mt-1 text-xs font-semibold">{option.monthDay}</p>
            {option.isToday ? (
              <p className={`mt-0.5 text-[10px] ${selectedDate === option.key ? 'text-white/80' : 'text-violet-500'}`}>
                今天
              </p>
            ) : null}
          </button>
        ))}
      </div>

      <p className="mt-4 text-xs font-semibold text-slate-500">选择时间段</p>
      <div className="mt-2 grid grid-cols-3 gap-2 sm:grid-cols-6">
        {slotOptions.map((slot) => (
          <button
            key={slot}
            onClick={() => onTimeChange(slot)}
            className={`rounded-xl border px-2 py-2 text-xs font-semibold transition-colors ${
              selectedTime === slot
                ? 'border-violet-500 bg-violet-600 text-white'
                : 'border-violet-200 bg-white text-slate-700 hover:border-violet-300'
            }`}
          >
            {slot}
          </button>
        ))}
      </div>
    </div>
  );
};

export default SchedulePicker;
